import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FormField = styled(Container)`
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  margin: 0px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 10px;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  margin-bottom: 10px;
`

export const Label = styled.label`
  text-align: center;
  color: #777777;
  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`

export const ButtonText = styled(SubTitle)`
  color: #FFFFFF;
  margin: 0px;
  font-weight: 200;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const DangerButton = styled(LookButton).attrs(buttonLook({ variant: 'primary', destructive: true }))`
  height: 36px;
  align-self: flex-end;
  margin: 0px;
`
